// src/pages/NotFound.js
import React from 'react';

const NotFound = () => {
  return (
    <section
      className="relative w-full overflow-hidden min-h-screen"
      style={{ backgroundColor: 'var(--bg-color)' }}
    >
      {/* Decorative background (gradient overlay) */}
      <div
        className="absolute inset-0 bg-gradient-to-r from-[var(--primary-color)] via-[var(--gradient-color)] to-[var(--primary-color)] opacity-20 pointer-events-none"
        aria-hidden="true"
      />

      <div className="max-w-7xl mx-auto px-4 pt-16 pb-24 relative z-10">
        <div className="text-center mb-10">
          <h1
            className="text-5xl font-extrabold mb-4"
            style={{ color: 'var(--primary-color)' }}
          >
            404
          </h1>
          <h2
            className="text-2xl font-bold mb-2"
            style={{ color: 'var(--text-color)' }}
          >
            Page Not Found
          </h2>
          <p
            className="mb-4"
            style={{ color: 'var(--text-color)' }}
          >
            Oops! The page you're looking for doesn't exist.
          </p>
          <p style={{ color: 'var(--muted-color)' }}>
            Please contact us at{' '}
            <a
              href="mailto:support@coursengage.com"
              className="hover:underline"
              style={{ color: 'var(--primary-color)' }}
            >
              support@coursengage.com
            </a>{' '}
            for assistance.
          </p>
        </div>
      </div>
    </section>
  );
};

export default NotFound;
